import { Columns } from '../../columns.jsx'

export const PerformanceColumns = [
    Columns.CPC,
    Columns.Cost,
    Columns.Sales,
    Columns.ACOS,
    Columns.ROAS,
    Columns.Impressions,
    Columns.Clicks,
    Columns.CTR,
    Columns.RPC,
    Columns.Orders,
    Columns.CVR,
    Columns.CAC,
    Columns.AOV,
]
